<template>
    <div class="Crisis_document">

      <transit :users="UserID"/>

      <div>
        <div style="margin-top: 10px;margin-left: 2%;">
          <el-button type="primary" @click="dialogVisible = true">上传文档</el-button>
          <el-button type="primary"  @click="dialogVisible2 = true, downfun()" style="margin-right: 40px;">模板下载</el-button>
        </div>
        <ul class="aaa">
          <li>
            <span>姓名：</span>
            <span>{{ Data.RealName }}</span>
          </li>
          <li>
            <span>学生ID:</span>
            <span>{{ Data.UserID }}</span>
          </li>
          <li>
            <span>所属院系:</span>
            <span>{{ Data.DeptName }}</span>
          </li>
          <li>
            资料类型：
            <el-select size="small" v-model="Type" placeholder="请选择资料类型" @change="qihuan()">
              <el-option label="全部" value=""></el-option>
              <el-option label="风险告知书" value="1"></el-option>
              <el-option label="免责声明" value="2"></el-option>
              <el-option label="住院委托书" value="3"></el-option>
              <el-option label="就医记录" value="4"></el-option>
              <el-option label="其他" value="5"></el-option>
            </el-select>
          </li>
        </ul>
      </div>
      
      <el-table :data="tableData" stripe style="width: 96%;margin-left:2%;margin-top:20px;">
        <el-table-column prop="UploadID" label="上传人" width="180"></el-table-column>
        <el-table-column prop="UploadTime" label="上传时间" width="180"></el-table-column>
        <el-table-column prop="FileType" label="资料类型"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="w" @click="look(scope.row.Fileaddres,1)">查看</span>
            <span class="w" @click="look(scope.row.Fileaddres,2)">下载</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="address" label="查看"></el-table-column> -->
      </el-table>

        <el-pagination style="margin-top:20px;" @current-change="handleCurrentChange" :current-page.sync="PageIndex" :page-size="10"  layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>
        <el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="学生学号" prop="name">
              <el-input v-model="ruleForm.name" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="学生姓名" prop="region">
              <el-input v-model="ruleForm.region" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="文档类型" prop="Type">
              <el-radio-group v-model="ruleForm.Type">
                <el-radio label="风险告知书"></el-radio>
                <el-radio label="免责申明"></el-radio>
                <el-radio label="住院委托书"></el-radio>
                <el-radio label="就医记录"></el-radio>
                <el-radio label="其他"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="文档" style="height: 150px;">
              <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png, .pdf, .jfif">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon">
                  <span style="font-size: 16px;">点击选择文件</span>
                </i>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <el-dialog title="查看" :visible.sync="dialogVisible3" width="50%" :before-close="handleClose">
          <div style="height: 800px;" >
            <img style="width: 100%;height: 100%;" :src="img" alt="">
          </div>
        </el-dialog>

      <el-dialog title="模板下载" :visible.sync="dialogVisible2" width="50%" :before-close="handleClose">
          <el-button v-for="(item, i ) in dewnfundata" :key="i" type="primary" @click="godown(item.fileaddres)">{{ item.fileType }}</el-button>
        <div style="height: 50px;">
        </div>
      </el-dialog>
    </div>
</template>

<script>
import transit from './transit'
  export default {
  data() {
      return {
        dewnfundata:[],
        img:"",
        file: '',
        dialogVisible3: false,
        imageUrl: '',
        UserID: '',
        Count: 0,
        currentPage: 10,
        Type: '',
        PageIndex: '',
        Data: [],
        pageIndex:1,
        ruleForm:{
          name:'',
          region:'',
          date1:'',
          date2:'',
          delivery:false,
          Type:[],
          resource:'',
          desc:''
        },
        rules: {
          name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          region:[{ required: true, message: '请选择活动区域', trigger: 'change'}],
          Type:[{ required: true, message: '请选择活动资源', trigger: 'change'}],
        },
        region:'',
        dialogVisible:false,
        dialogVisible2:false,
        tableData:[],
      }
    },
    components: {
      transit,
    },
  methods: {
    downloadIamge(imgsrc, name, tupe) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);



        if (tupe == '.png') {
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
        } else if (tupe == '.jpg') {
          var url = canvas.toDataURL("image/jpg"); //得到图片的base64编码数据'
        }
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        }); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    look(val, type) {
      if (type == 1) {
        if (val.substring(val.length - 3) !== 'pdf') {
          this.img = val;
          this.dialogVisible3 = true
        } else {
          window.open(val);
        }
      } else {
        if (val.substring(val.length - 3) == 'pdf' && val.substring(val.length - 3) == 'doc' ) {
          window.open(val)
        } else if (val.substring(val.length - 3) == 'png') {
          window.open(val)
          // var fileName = new Date().getTime() + ".png";
          // this.downloadIamge(val, fileName, ".png");
        } else {
          window.open(val)
          // var fileName = new Date().getTime() + ".jpg";
          // this.downloadIamge(val, fileName,".jpg");
        }
      }
    },
    godown(a) {
      window.open(a)
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png' || file.raw.type == "application/pdf") {
        if (file.raw.type == "application/pdf") {
          this.imageUrl = "https://t9.baidu.com/it/u=3917977667,2615684315&fm=193"
        } else {
          this.imageUrl = URL.createObjectURL(file.raw);
        }
        this.file = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片'})
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.load();
      //分页点击
    },
    qihuan() {
        this.load();
      },
      down(val){

    },
    downfun() {
        this.$Http_Post('management/distressPrediction/selectStuDocument', {}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.dewnfundata = res.Data;
          }
        });
      },
      handleClose(done) {
        this.$confirm('确认关闭？').then(_ => {done();})
          .catch(_ => {});
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var from = new FormData();
            from.append('UploadDocument', this.file.raw);
            from.append('RealName', this.ruleForm.name);
            from.append('UserID', this.ruleForm.region);
            from.append('Type', this.ruleForm.Type);
            from.append('TypeOther', "TypeOther");
            this.$Http_Post('DistressPrediction/StuUploadDocument', from, {'Content-Type': 'multipart/form-data', })
            .then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.dialogVisible = false;
                this.load();
                this.Global.request_successful(res.Message);
              } else {
                this.Global.request_failure(res.Message);
              }
            })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      load(form) {//列表
        this.$Http_Post('DistressPrediction/StuCrisisDocumentation',{ PageSize:10, PageIndex:this.pageIndex,UserID:this.UserID, Type:this.Type }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Count = res.Counts;
          }
        });
      },
    },
  mounted() {
      this.UserID = [this.$route.query.UserID][0];
      this.$Http_Post('DistressPrediction/StuBasicFile', { UserID: this.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Data = res.Data;
          this.ruleForm.name = res.Data.RealName
          this.ruleForm.region = res.Data.UserID
          
        }
      });
      this.load();
      // this.username = JSON.parse(localStorage.getItem('Psychological_archives')).RealName;
      // this.DeptName = JSON.parse(localStorage.getItem('Psychological_archives')).DeptName;
    }
  }
</script>

<style>
.Crisis_document{width: 100%;height: 100%;background-color: #fff;}
.Crisis_document .aaa li{float: left;line-height: 40px;margin-left: 2%;}
.Crisis_document .dialog_li{height: 400px;}
.Crisis_document .dialog_li li{height: 60px;position: relative;width: 80%;}
.Crisis_document .dialog_li li img{width: 40px;height: 40px;padding-top: 10px;position: absolute;top: 10px;left: 20px;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.Crisis_document .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Crisis_document .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.Crisis_document .avatar-uploader {position: absolute;top: 0px;left: 0px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
.scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
</style>